import React from "react";
import { newsItems} from "../../pages/NewsPage";

// News Section Component
const NewsSection = () => {
    const newsItem = newsItems.slice(0,3);

    return (
        <div className="px-4 md:px-20 py-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 md:mb-12 text-center">
                Latest News
            </h2>
            <div className="flex flex-col md:flex-row justify-center space-y-6 md:space-y-0 md:space-x-8">
                {newsItem.map((item, index) => (
                    <div
                        key={index}
                        className="w-full md:w-80 bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl overflow-hidden shadow-xl transform transition-all duration-300 md:hover:scale-105 flex flex-col"
                    >
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            className="w-full h-48 object-cover"
                        />
                        <div className="p-6 flex flex-col flex-grow">
                            <h3 className="text-xl md:text-2xl font-semibold text-white mb-4">
                                {item.title}
                            </h3>
                            <p className="text-white/80 mb-6 flex-grow">
                                {item.description}
                            </p>
                            <a 
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-white/20 text-white py-3 rounded-full hover:bg-white/30 transition-colors mt-auto text-center"
                            >
                                Read More
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NewsSection;